import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending } from '@reduxjs/toolkit';
import { EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { defaultValue } from 'app/shared/model/absence.model';
import { IAbsence } from 'app/shared/model/absence.model';
import { IProfesseur } from 'app/shared/model/professeur.model';
const initialState: EntityState<IAbsence> = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAbsence>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0,
};

const apiUrl = 'api/professeurs';

// Actions

export const getProfesseurAbsences = createAsyncThunk('professeurs/absences', async (professeurId: string | number) => {
  const requestUrl = `${apiUrl}/${professeurId}/absences`;
  return axios.get<IAbsence[]>(requestUrl);
});

export const resetAbsences = createAsyncThunk(
  'professeurs/delete_absences',
  async (entity: IProfesseur, thunkAPI) => {
    const requestUrl = `${apiUrl}/${entity.id}/absences`;
    const result = await axios.delete<IAbsence>(requestUrl);
    thunkAPI.dispatch(getProfesseurAbsences(entity.id));
    return result;
  },
  { serializeError: serializeAxiosError }
);

export type ClassetState = Readonly<typeof initialState>;

// slice

export const ClasseSlice = createSlice({
  name: 'absences',
  initialState: initialState as ClassetState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(resetAbsences.fulfilled, state => {
        state.updating = false;
        state.updateSuccess = true;
        state.entity = {};
      })
      .addMatcher(isPending(getProfesseurAbsences, resetAbsences), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isFulfilled(getProfesseurAbsences), (state, action) => {
        state.loading = false;
        state.entities = action.payload.data;
        state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
      });
  },
});

export const { reset } = ClasseSlice.actions;

// Reducer
export default ClasseSlice.reducer;
